import {createSlice, PayloadAction, createAsyncThunk} from '@reduxjs/toolkit';
import { type RootState } from '../../store';
import { AccountInfo, EventMessageUtils } from '@azure/msal-browser';
import axios from 'axios';

// Define a type for the slice state
export interface UserState {
  account?: AccountInfo
  layout : string
}

// Define the initial state using that type
const initialState: UserState = {
    account: undefined,
    layout: JSON.stringify([
      { i: "overview", x: 0, y: 0, w: 12, h: 2, static: true },
      { i: "navdata", x: 0, y: 2, w: 5, h: 9, static: true },
      { i: "meteodata", x: 5, y: 2, w: 4, h: 5, static: true },
      { i: "map", x: 9, y: 2, w: 3, h: 9, static: true },
      { i: "flowdata", x: 9, y: 11, w: 3, h: 3, static: true },
      { i: "winchdata", x: 0, y: 11, w: 9, h: 8, static: true }
    ])
}

export const getLayout = createAsyncThunk("users/layouts/getByUser", async(username:string|undefined)=>{
  const response = await fetch(process.env.REACT_APP_API_URI + `/users/layouts/getByUser?user=`+username,{
      method:"GET"
  });
  const data = response.json()
  return data;

});

export const UserSlice = createSlice({
  name: 'User',
  initialState,
  reducers: {
  //   getLayout:(state)=>{
  //     axios.get(process.env.REACT_APP_API_URI + `/users/layouts/getByUser/?user=`+state.account?.username)
  //     .then(response=>{
  //       state.layout = response.data;
  //     });
  //   }
  // ,
    setUser: (state, action: PayloadAction<AccountInfo|undefined>)=>{
      state.account = action.payload
      const loginUser = async() => {
        await axios.post(process.env.REACT_APP_API_URI + `/users/login`, {email:state.account?.username})
      }
      loginUser();
    },
    
  },
  extraReducers: (builder) => {
      builder.addCase(getLayout.fulfilled, (state, {payload}:PayloadAction<string>) => {
          state.layout = payload;
      })
    }
});
    

export const {setUser} = UserSlice.actions


export default UserSlice.reducer